module.exports = __webpack_public_path__ + "img/everton-fc.a9f9c8b0.png";